import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.746 19.7a2.81 2.81 0 0 1-2.696 2.05 2.8 2.8 0 0 1-.634-5.527L4.36 7.72A2.8 2.8 0 1 1 7.898 4.3h8.214a2.8 2.8 0 0 1 5.498.75 2.81 2.81 0 0 1-1.97 2.671l.98 8.499a2.8 2.8 0 0 1 1.708 1.174 2.8 2.8 0 0 1 .472 1.556 2.81 2.81 0 0 1-2.8 2.8 2.8 2.8 0 0 1-2.698-2.05zM17.254 7.378c.27.18.57.312.881.39l.983 8.524a2.8 2.8 0 0 0-1.815 1.908H6.747a2.8 2.8 0 0 0-1.864-1.923l.988-8.511A2.81 2.81 0 0 0 7.895 5.8h8.217a2.8 2.8 0 0 0 1.142 1.578M5.351 18.921A1 1 0 0 0 5.35 19a1.3 1.3 0 1 1-1.304-1.35h.006a1.3 1.3 0 0 1 1.299 1.27M17.51 5.07a1.3 1.3 0 0 0 .38.898 1.3 1.3 0 1 0-.38-.94v.042m2.43 12.58.06-.001h.006a1.3 1.3 0 1 1-.066.001M5.19 3.75a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }